(function () {
  if (window.__EDD_INITED__) return;
  window.__EDD_INITED__ = true;

  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay(); // 0 Sun, 6 Sat
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  };

  const renderAll = () => {
    const nodes = document.querySelectorAll("[data-edd]");
    if (!nodes.length) return;

    const fmt = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });

    nodes.forEach((el) => {
      const procMin = parseInt(el.dataset.procMin || "1", 10);
      const procMax = parseInt(el.dataset.procMax || "2", 10);
      const shipMin = parseInt(el.dataset.shipMin || "3", 10);
      const shipMax = parseInt(el.dataset.shipMax || "6", 10);

      const today = new Date();
      const minDate = addBusinessDays(today, procMin + shipMin);
      const maxDate = addBusinessDays(today, procMax + shipMax);

      const target = el.querySelector(".edd-range");
      if (target) target.textContent = `${fmt.format(minDate)} - ${fmt.format(maxDate)}`;
    });
  };

  window.EDD_RENDER = renderAll;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderAll);
  } else {
    renderAll();
  }
})();
